export const widgets = [
    { widget: 'actionPlanner', categories: ['Competencies'], defaultW: 6, defaultH: 8 },
    { widget: 'competencyOverTime', categories: ['Competencies'] },
    { widget: 'competencyAgainstMetric', categories: ['Competencies', 'Metrics'] },
    { widget: 'focusCompetencies', categories: ['Competencies'] },
    { widget: 'competencyGrid', categories: ['Competencies'] },
    { widget: 'competencyROI', categories: ['Competencies', 'Metrics'], crmOnly: true, defaultW: 3, defaultH: 6 },
    { widget: 'goalsAchieved', categories: ['Goals'] },
    { widget: 'goalsAchievedPie', categories: ['Goals'] },
    { widget: 'goalsOverTime', categories: ['Goals'] },
    { widget: 'leaderboard', categories: ['Competencies', 'Metrics', 'Goals'] },
    { widget: 'matrix', categories: ['Competencies', 'Metrics', 'Goals'] },
    { widget: 'metricsOverTime', categories: ['Metrics'] },
    { widget: 'metricOverTime', categories: ['Metrics'] },
    { widget: 'predictiveModel', categories: ['Competencies', 'Metrics', 'Goals'], crmOnly: true, defaultW: 6, defaultH: 7 },
    { widget: 'rampTimes', categories: ['Metrics'], crmOnly: true },
    { widget: 'salesVelocity', categories: ['Metrics', 'Competencies'], crmOnly: true },
    { widget: 'teamRatings', categories: ['Competencies'] },
    { widget: 'radarCompetencies', categories: ['Competencies'] },
];

export default widgets;
